<script setup lang="ts">
const props = defineProps<{
  /** Wether the line should start at the edge or at the icon. Defaults to icon */
  topEnd?: 'icon' | 'edge';
  /** Wether the line should end at the edge or at the icon. Defaults to icon */
  bottomEnd?: 'icon' | 'edge';
  /** Defaults to 2em */
  iconSize?: string;
  /** Vertical offset of icons. Defaults to `--nxt-space-xs` */
  iconYOff?: string;
}>();
</script>

<template>
  <div
    class="nx-timeline-container"
    :style="`--icon-size: ${props.iconSize ?? '2em'}; --icon-y-off: ${props.iconYOff ?? 'var(--nxt-space-xs)'}`"
    :data-top-end="props.topEnd ?? 'icon'"
    :data-bottom-end="props.bottomEnd ?? 'icon'"
  >
    <slot />
  </div>
</template>

<style scoped>
.nx-timeline-container {
  display: grid;
  grid-template-columns: var(--icon-size) 1fr;
  --gap: var(--nxt-space-sm);
  gap: var(--gap);
}
</style>
